import { cn } from '@/lib/utils';

interface PassoIndicadorProps {
  passoAtual: 1 | 2 | 3;
}

const passos = [
  { numero: 1, label: 'Criação do cabeçalho do relatório' },
  { numero: 2, label: 'Configurar separações e ordenações' },
  { numero: 3, label: 'Configurar totalizadores' },
] as const;

export function PassoIndicador({ passoAtual }: PassoIndicadorProps) {
  return (
    <div className="flex items-center gap-6 border-b bg-muted/20 px-6 py-4">
      {passos.map(({ label, numero }) => (
        <div
          key={numero}
          className={cn('flex items-center gap-3', passoAtual !== numero && 'opacity-40')}
        >
          <div
            className={cn(
              'flex h-8 w-8 items-center justify-center rounded-full text-sm font-semibold',
              passoAtual === numero
                ? 'bg-primary text-primary-foreground shadow-md'
                : 'border-2 bg-muted text-muted-foreground'
            )}
          >
            {numero}o
          </div>
          <span
            className={cn(
              'text-sm',
              passoAtual === numero ? 'font-medium' : 'text-muted-foreground'
            )}
          >
            {label}
          </span>
        </div>
      ))}
    </div>
  );
}
